// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/keen-slider@5.5.1'

class SectionMobileCarousel extends HTMLElement {
  constructor () {
    super()

    this.slideEls = this.querySelectorAll('[data-el="section-carousel.slide"]')
    if (this.slideEls.length < 2) return

    this.slidesEl = this.querySelector('[data-el="section-carousel.slides"]')
    this.progressEl = this.querySelector(
      '[data-el="section-carousel.progress"]'
    )

    this.slidesPerView = parseInt(this.dataset.slidesPerView) || 2.5
    this.slidesPerView768 = parseInt(this.dataset.slidesPerView768) || 3.4

    this.destroyWidth = window.matchMedia('(min-width: 1200px)')
    this.slideInterval = 0

    this.carousel = this.initialiseCarousel()
    this.setupListeners()
    this.autoplay(true)
  }

  setupListeners () {
    this.CarouselSwitcher = this.CarouselSwitcher.bind(this)
    window.addEventListener('resize', this.CarouselSwitcher)
    this.slidesEl.addEventListener('mouseover', () => {
      this.autoplay(false)
    })
    this.slidesEl.addEventListener('mouseout', () => {
      this.autoplay(true)
    })
  }

  CarouselSwitcher () {
    if (this.carousel && this.destroyWidth.matches) {
      this.carousel = this.destroyCarousel()
    } else if (!this.carousel && !this.destroyWidth.matches) {
      this.carousel = this.initialiseCarousel()
    }
  }

  initialiseCarousel () {
    if (this.carousel || this.destroyWidth.matches) return
    this.autoplay(true)
    this.slidesEl.setAttribute('cursor-element', 'carousel')

    return new KeenSlider(this.slidesEl, {
      duration: 3000,
      loop: true,
      centered: true,
      mode: 'snap',
      slides: '.car-Carousel_Slide',
      slidesPerView: this.slidesPerView,
      spacing: 5,
      breakpoints: {
        '(min-width: 768px)': {
          loop: true,
          centered: false,
          slidesPerView: this.slidesPerView768,
        },
      },
      move: instance => {
        if (this.progressEl) {
          const progressTrack = instance.details().progressTrack
          const progressAmount = progressTrack >= 0.9 ? 0 : progressTrack
          const movementPercentage = progressAmount * 100
          this.progressEl.style.setProperty(
            '--progress',
            `${movementPercentage}%`
          )
        }
        this.resetCarousel()
      },
      created: () => {
        this.autoplay(true)
      },
      dragStart: () => {
        this.autoplay(false)
      },
      dragEnd: () => {
        this.autoplay(true)
      },
      destroyed: () => {
        this.autoplay(false)
        this.resetCarousel()
      },
      slideChanged: instance => {
        this.slideEls.forEach((slide, index) => {
          slide.setAttribute(
            'aria-hidden',
            index !== instance.details().relativeSlide
          )
        })
      },
    })
  }

  destroyCarousel () {
    this.autoplay(false)
    this.slidesEl.setAttribute('cursor-element', null)
    this.carousel.destroy()
  }

  resetCarousel () {
    if (!this.destroyWidth.matches) return

    this.slideEls.forEach(slide => {
      slide.style.setProperty('max-width', '')
      slide.style.setProperty('transform', '')
      slide.style.setProperty('min-width', '')
    })
  }

  autoplay (run) {
    clearInterval(this.slideInterval)
    this.slideInterval = setInterval(() => {
      if (run && this.carousel) {
        this.carousel.next()
      }
    }, 3000)
  }
}

customElements.define('section-mobile-carousel', SectionMobileCarousel)
